"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reduxForm = require("redux-form");

var _Component = _interopRequireDefault(require("./Component"));

var FORM_NAME = 'operation-payout-from-file';

var asyncValidate = function asyncValidate(values) {
  return new Promise(function (resolve, reject) {
    if (!values['shopId']) {
      reject({
        shopId: 'Обязательное поле'
      });
    }

    resolve(values);
  });
};

var validate = function validate(values) {
  var errors = {};

  if (!values['shopId']) {
    errors['shopId'] = 'Обязательное поле';
  }

  return errors;
};

var _default = (0, _reduxForm.reduxForm)({
  form: FORM_NAME,
  asyncValidate: asyncValidate,
  validate: validate
})(_Component["default"]);

exports["default"] = _default;